module.exports = __webpack_public_path__ + "img/mico-main.2cb79d1d.jpg";